export enum ListingChipLabels {
  New = 0,
  TopAd = 1,
  ReactForFree = 2,
  StillAvailable = 3,
}

export enum PetAllowanceNormalized {
  Yes = 1,
  No = 2,
  MutualAgreement = 3,
}

export const getPetAllowanceAPIValue = (
  normalized: PetAllowanceNormalized,
): boolean => {
  if (normalized === PetAllowanceNormalized.Yes) {
    return true;
  }

  return false;
};

export const normalizePetAllowance = (
  apiValue: boolean | null | undefined,
): PetAllowanceNormalized => {
  if (apiValue) {
    return PetAllowanceNormalized.Yes;
  }
  if (apiValue === false) {
    return PetAllowanceNormalized.No;
  }

  return PetAllowanceNormalized.MutualAgreement;
};
